import { shadows } from '@alison/ui';

export const PREVIEW_POPOVER_SX = { pointerEvents: 'none' };

export const PREVIEW_PAPER_SX = {
  pointerEvents: 'auto',
  maxWidth: 'none',
  p: 2,
  bgcolor: 'background.paper',
  color: 'text.primary',
  borderRadius: 1,
  boxShadow: shadows.dropdown,
};
